import { ensureContrast } from './color.util';

const SECTION_PAIRS: [string, string][] = [
  ['font_main_color', 'bg_main_color'],
  ['font_primary_color', 'bg_primary_color'],
  ['font_secondary_color', 'bg_secondary_color'],
  ['button_font_primary_color', 'button_bg_primary_color'],
  ['button_font_secondary_color', 'button_bg_secondary_color'],
  ['card_font_color', 'card_bg_color'],
];

/** Each saved text colour and the background Webpage Settings pairs it with. */
const TEXT_ON_BG: [string, string][] = [
  ['font_primary_color', 'bg_primary_color'],
  ['font_secondary_color', 'bg_secondary_color'],
  ['font_tertiary_color', 'bg_tertiary_color'],
  ['form_font_secondary_color', 'form_bg_color'],
  ...['event', 'merchandise'].flatMap(section =>
    SECTION_PAIRS.map(([font, bg]): [string, string] => [`${section}_${font}`, `${section}_${bg}`])),
];

/**
 * Networks can save a text colour that is unreadable on its own background (e.g. #4a4a4a on
 * #292929). Nudges each such colour toward black/white until it reaches 4.5:1, keeping the
 * saved hue, so every page reading settingsData gets readable text without per-page fixes.
 */
export function withReadableThemeText(settings: any): any {
  if (!settings) return settings;
  const out = { ...settings };
  for (const [font, bg] of TEXT_ON_BG) {
    if (out[font] && out[bg]) {
      out[font] = ensureContrast(out[font], out[bg]);
    }
  }
  return out;
}
